import axios from "axios";
let BASE_URL = process.env.NODE_ENV === "production" ? process.env.VUE_APP_API_URL : "";
export default {
    state: {
    
    },
    getters: {
        
    },
    actions: {
        fetchActivityType({ }) {
            return new Promise((resolve,reject) => {
                axios.get(`${BASE_URL}/users/admin/activity/type`).then(response => {
                    resolve(response.data.data)
                }).catch(error => {
                    reject(error.response.data)
                })
            })
        },
        fetchActivityLogsByType({ }, type) {
            return new Promise((resolve,reject) => {
                axios.get(`${BASE_URL}/users/admin/activity/by/type/${type}`).then(response => {
                    resolve(response.data.data)
                }).catch(error => {
                    reject(error.response.data)
                })
            })
        }
    },
    mutations: {

    },
};
